/* Native Shopify contact submission; this element only adapts the visible fields. */
(() => {
  if (customElements.get('hok-contact')) return;

  class HokContact extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.form = this.querySelector('form');
      this.intent = this.querySelector('[data-hok-contact-intent]');
      this.result = this.querySelector('[data-hok-contact-result]');

      if (!this.form || !this.intent) {
        this.result?.focus({ preventScroll: true });
        return;
      }

      const query = new URLSearchParams(window.location.search);
      if (!this.result) this.applyContext(query);
      this.updateFields();
      this.intent.addEventListener('change', () => this.updateFields(), { signal });
      this.querySelectorAll('[data-hok-callback-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.intent.value = 'Callback request';
          this.updateFields();
          this.intent.focus();
          this.querySelector('#contact-form')?.scrollIntoView({ behavior: 'auto', block: 'start' });
        }, { signal });
      });
      this.result?.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    applyContext(query) {
      const intents = {
        project: 'Project inquiry',
        callback: 'Callback request',
        support: 'Existing order support',
        general: 'General question',
      };
      const intent = intents[query.get('intent')];
      if (intent) this.intent.value = intent;

      const categories = {
        sculpture: 'Sculpture & fountains',
        art: 'Sculpture & fountains',
        sculptures: 'Sculpture & fountains',
        fountains: 'Sculpture & fountains',
        solar: 'Solar power',
        laser: 'Bird deterrence',
        bird: 'Bird deterrence',
        'bird-deterrence': 'Bird deterrence',
        equipment: 'Equipment',
      };
      const category = categories[(query.get('category') || '').toLowerCase()];
      const categoryField = this.querySelector('[data-hok-contact-category]');
      if (category && categoryField) categoryField.value = category;

      const subject = query.get('subject') || query.get('product');
      const context = query.get('context') || query.get('source');
      if (subject) this.querySelector('[data-hok-contact-subject]').value = subject.slice(0, 300);
      if (context) this.querySelector('[data-hok-contact-context]').value = context.slice(0, 700);
    }

    toggleGroup(selector, visible) {
      this.querySelectorAll(selector).forEach((group) => {
        group.hidden = !visible;
        group.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !visible;
        });
      });
    }

    updateFields() {
      const callback = this.intent.value === 'Callback request';
      const support = this.intent.value === 'Existing order support';
      const project = callback || this.intent.value === 'Project inquiry';
      this.toggleGroup('[data-hok-project-fields]', project);
      this.toggleGroup('[data-hok-order-fields]', support);
      this.toggleGroup('[data-hok-callback-fields]', callback);

      const phone = this.querySelector('[data-hok-contact-phone]');
      phone.required = callback;
      this.querySelector('[data-hok-phone-note]').textContent = callback ? '*' : '(optional)';
      this.querySelector('[data-hok-contact-category]').required = project;
      this.querySelector('[data-hok-contact-location]').required = project;
      this.querySelectorAll('[data-hok-project-required]').forEach((marker) => {
        marker.textContent = project ? '*' : '';
      });
      this.querySelector('[data-hok-contact-submit-label]').textContent = callback ? 'Request callback' : 'Send message';
      this.querySelector('[data-hok-contact-message-help]').textContent = support
        ? 'Describe what you need help with, including the product and any relevant order details.'
        : project
          ? 'Tell us what you’re considering, how it will be used and any questions you’d like us to answer.'
          : 'Tell us what you’d like to know or discuss.';
    }
  }

  customElements.define('hok-contact', HokContact);
})();
